export enum PlansSalesToolsEnum {
  REX = "Rex",
  AGENT_BOX = "AgentBox",
  VAULT_RE = "VaultRE",
  SALES_FORCE = "Salesforce",
  EXCEL = "Excel",
  OTHER = "Other",
}
